import React, { useState } from 'react';
import { Card, CardHeader, CardBody, Collapse, FormGroup, Label, Input } from 'reactstrap';
import ColorPickerInput from './ColorPickerInput';

const TextStyleInputs = ({ label, styleConfig = {}, onChange }) => {
    const [collapsed, setCollapsed] = useState(true);

    const updateStyle = (updates) => {
        onChange({ ...styleConfig, ...updates });
    };

    return (
        <Card className="mb-3">
            <CardHeader
                className="d-flex justify-content-between align-items-center bg-light"
                style={{ cursor: 'pointer' }}
                onClick={() => setCollapsed(!collapsed)}
            >
                <span className="fw-semibold small text-dark">{label}</span>
                <span className="small text-muted">{collapsed ? '▶' : '▼'}</span>
            </CardHeader>
            <Collapse isOpen={!collapsed}>
                <CardBody className="p-3">
                    <FormGroup className="mb-2">
                        <Label className="text-muted small mb-1">Schriftgröße (z.B. 2rem, 16px)</Label>
                        <Input
                            type="text"
                            value={styleConfig.fontSize || ''}
                            onChange={(e) => updateStyle({ fontSize: e.target.value || undefined })}
                            placeholder="Standard"
                        />
                    </FormGroup>

                    <ColorPickerInput
                        label="Textfarbe"
                        value={styleConfig.color}
                        onChange={(val) => updateStyle({ color: val })}
                        placeholder="z.B. #000000"
                    />

                    <ColorPickerInput
                        label="Hintergrundfarbe"
                        value={styleConfig.backgroundColor}
                        onChange={(val) => updateStyle({ backgroundColor: val })}
                        placeholder="z.B. #ffffff"
                    />

                    <FormGroup className="mb-2">
                        <Label className="text-muted small mb-1">Schriftgewicht (Weight)</Label>
                        <Input
                            type="select"
                            value={styleConfig.fontWeight || ''}
                            onChange={(e) => updateStyle({ fontWeight: e.target.value || undefined })}
                        >
                            <option value="">Standard</option>
                            <option value="normal">Normal</option>
                            <option value="bold">Bold (Fett)</option>
                            <option value="100">Thin (100)</option>
                            <option value="200">Extra Light (200)</option>
                            <option value="300">Light (300)</option>
                            <option value="400">Regular (400)</option>
                            <option value="500">Medium (500)</option>
                            <option value="600">Semi Bold (600)</option>
                            <option value="700">Bold (700)</option>
                            <option value="800">Extra Bold (800)</option>
                            <option value="900">Black (900)</option>
                        </Input>
                    </FormGroup>

                    <FormGroup className="mb-2">
                        <Label className="text-muted small mb-1">Schriftstil (Style)</Label>
                        <Input
                            type="select"
                            value={styleConfig.fontStyle || ''}
                            onChange={(e) => updateStyle({ fontStyle: e.target.value || undefined })}
                        >
                            <option value="">Standard</option>
                            <option value="normal">Normal</option>
                            <option value="italic">Italic (Kursiv)</option>
                        </Input>
                    </FormGroup>

                    <FormGroup className="mb-2">
                        <Label className="text-muted small mb-1">Zeilenhöhe (Line-Height, z.B. 1.2, 28px)</Label>
                        <Input
                            type="text"
                            value={styleConfig.lineHeight || ''}
                            onChange={(e) => updateStyle({ lineHeight: e.target.value || undefined })}
                            placeholder="Standard"
                        />
                    </FormGroup>

                    <FormGroup className="mb-2">
                        <Label className="text-muted small mb-1">
                            Schlagschatten (Text-Shadow, z.B. 0 2px 4px rgba(0,0,0,0.5))
                        </Label>
                        <Input
                            type="text"
                            value={styleConfig.textShadow || ''}
                            onChange={(e) => updateStyle({ textShadow: e.target.value || undefined })}
                            placeholder="Standard"
                        />
                    </FormGroup>

                    <FormGroup className="mb-2">
                        <Label className="text-muted small mb-1">Schriftfamilie (z.B. Outfit, sans-serif)</Label>
                        <Input
                            type="text"
                            value={styleConfig.fontFamily || ''}
                            onChange={(e) => updateStyle({ fontFamily: e.target.value || undefined })}
                            placeholder="Standard"
                        />
                    </FormGroup>

                    <FormGroup className="mb-2">
                        <Label className="text-muted small mb-1">Text-Transformation</Label>
                        <Input
                            type="select"
                            value={styleConfig.textTransform || ''}
                            onChange={(e) => updateStyle({ textTransform: e.target.value || undefined })}
                        >
                            <option value="">Standard (none)</option>
                            <option value="uppercase">Großbuchstaben (uppercase)</option>
                            <option value="lowercase">Kleinbuchstaben (lowercase)</option>
                            <option value="capitalize">Wortanfang Groß (capitalize)</option>
                        </Input>
                    </FormGroup>

                    <FormGroup className="mb-0">
                        <Label className="text-muted small mb-1">Zeichenabstand (z.B. 1px, 0.05em)</Label>
                        <Input
                            type="text"
                            value={styleConfig.letterSpacing || ''}
                            onChange={(e) => updateStyle({ letterSpacing: e.target.value || undefined })}
                            placeholder="Standard"
                        />
                    </FormGroup>
                </CardBody>
            </Collapse>
        </Card>
    );
};

export default TextStyleInputs;
